import img_01 from "../../../assets/images/head-offiece-01.jpg"
import img_02 from "../../../assets/images/head-offiece-02.jpg"
export const contactInfo = [
  {
    icon: 'location',
    title: 'Địa chỉ 1',
    content: '123 Nguyễn Huệ, Quận 1, TP.HCM',
  },
  {
    icon: 'location',
    title: 'Địa chỉ 2',
    content: '456 Nguyễn Thị Thập, Quận 7, TP.HCM',
  },
  {
    icon: 'location',
    title: 'Địa chỉ 3',
    content: '789 Võ Văn Ngân, TP. Thủ Đức, TP.HCM',
  },
  {
    icon: 'phone',
    title: 'Điện thoại',
    content: '0352032375',
  },
  {
    icon: 'mail',
    title: 'Email',
    content: 'pcvinh.info.dev@gmail.com',
  },
  {
    icon: 'clock',
    title: 'Giờ làm việc',
    content: 'T2-T6: 8:00 - 18:00\nT7: 8:00 - 12:00',
  },
  
];


export const branches = [
  {
    id: 1,
    district: 'Quận 1',
    address: '123 Nguyễn Huệ, Quận 1, TP.HCM',
    phone: '0123 456 789',
    email: 'q1@realestate.com',
    image: img_01
  },
  {
    id: 2,
    district: 'Quận 7',
    address: '456 Nguyễn Thị Thập, Quận 7, TP.HCM',
    phone: '0123 456 790',
    email: 'q7@realestate.com',
    image: img_02
  },
  {
    id: 3,
    district: 'Thủ Đức',
    address: '789 Võ Văn Ngân, TP. Thủ Đức, TP.HCM',
    phone: '0123 456 791',
    email: 'thuduc@realestate.com',
    image: img_01
  },
];

export const opt = [
  { label: "Mua Bán Nhà Đất", value: "mua-ban-nha-dat" },
  { label: "Cho Thuê Nhà Đất", value: "cho-thue-nha-dat" },
  { label: "Dự Án Bất Động Sản", value: "du-an-bat-dong-san" },
  { label: "Tư Vấn Pháp Lý", value: "tu-van-phap-ly" },
]
